export default "__VITE_ASSET__f6310103__"